export enum ComportementRetourEnum {
  Retour = 'retour',
  AfficherModaleAnnulation = 'afficher-modale-annulation',
  RetourEvenement = 'retour-evenement'
}
